export default {
  country: 'País',
  language: 'Idioma',
  currency: 'Moeda',
}
